import { render, staticRenderFns } from "./editProductBank.vue?vue&type=template&id=732b35b0&scoped=true"
import script from "./editProductBank.vue?vue&type=script&lang=ts"
export * from "./editProductBank.vue?vue&type=script&lang=ts"
import style0 from "./editProductBank.vue?vue&type=style&index=0&id=732b35b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732b35b0",
  null
  
)

export default component.exports